import { render, staticRenderFns } from "./TagsFilters.vue?vue&type=template&id=4efb2beb&"
import script from "./TagsFilters.vue?vue&type=script&lang=ts&"
export * from "./TagsFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efb2beb')) {
      api.createRecord('4efb2beb', component.options)
    } else {
      api.reload('4efb2beb', component.options)
    }
    module.hot.accept("./TagsFilters.vue?vue&type=template&id=4efb2beb&", function () {
      api.rerender('4efb2beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/TagsFilters.vue"
export default component.exports